/* eslint-disable @typescript-eslint/naming-convention */
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Loader, ServiceIcons, ViewportContext } from "@monorepo/components";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { convertNumberToCurrency } from "@monorepo/helpers";
import { useGetMyVouchersQuery } from "@monorepo/services/api/vouchers";
import theme from "@monorepo/styles/theme";
import { ServiceCategoryIdEnum } from "@monorepo/types";
import { Box, ListItem, Typography } from "@mui/material";
import { reverse } from "named-urls";

export const GsmMyVoucherList = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { data, isLoading } = useGetMyVouchersQuery();
  const { isSmMobile } = useContext(ViewportContext);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Box
        sx={{
          padding: theme.spacing(0, 2),
          [theme.breakpoints.down("md")]: {
            width: "100vw",
          },
        }}
      >
        {data?.map(({ id, valid_date, price, gsm_code }) => {
          return (
            <ListItem
              sx={{
                width: "100%",
                maxWidth: "600px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                columnGap: theme.spacing(2),
                cursor: "pointer",
                padding: "12px",
                borderRadius: "12px",
                backgroundColor: "inherit",
                color: "inherit",
                "&:hover": {
                  color: theme.palette.secondary.main,
                  background: theme.palette.card.dark,
                },
                [theme.breakpoints.down("md")]: {
                  maxWidth: "unset",
                },
              }}
              role="presentation"
              tabIndex={-1}
              key={id}
              onClick={() =>
                history.push(
                  reverse(routeConfig.dashboard.services.gsmVouchers.myVouchers.voucherId, {
                    voucherId: id,
                  })
                )
              }
            >
              <ServiceIcons serviceId={ServiceCategoryIdEnum.TELECOMMUNICATIONS} />
              <Typography component="span">{valid_date}</Typography>
              {!isSmMobile && (
                <Typography component="span">
                  {t("gsmVoucherServices.gsm_code")}&nbsp;
                  {gsm_code}
                </Typography>
              )}
              <Typography component="span">{convertNumberToCurrency(price)}</Typography>
            </ListItem>
          );
        })}
      </Box>
    </>
  );
};

export default GsmMyVoucherList;
